import {
  LIST_SUMMARY_GENERATOR_REQUEST,
  LIST_SUMMARY_GENERATOR_SUCCESS,
  LIST_SUMMARY_GENERATOR_FAIL,
  CREATE_SUMMARY_GENERATOR_REQUEST,
  CREATE_SUMMARY_GENERATOR_SUCCESS,
  CREATE_SUMMARY_GENERATOR_FAIL,
  DETAIL_SUMMARY_GENERATOR_REQUEST,
  DETAIL_SUMMARY_GENERATOR_SUCCESS,
  DETAIL_SUMMARY_GENERATOR_FAIL,
  UPDATE_SUMMARY_GENERATOR_REQUEST,
  UPDATE_SUMMARY_GENERATOR_SUCCESS,
  UPDATE_SUMMARY_GENERATOR_FAIL,
  DELETE_SUMMARY_GENERATOR_REQUEST,
  DELETE_SUMMARY_GENERATOR_SUCCESS,
  DELETE_SUMMARY_GENERATOR_FAIL,
  DUPLICATE_SUMMARY_GENERATOR_REQUEST,
  DUPLICATE_SUMMARY_GENERATOR_SUCCESS,
  DUPLICATE_SUMMARY_GENERATOR_FAIL
} from '../../constants/summary-generator'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  summaryGenerators: [],
  summaryGenerator: {},
  error: ''
}

const summaryGeneratorReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryGenerators: action.payload
      }
    case LIST_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loading: false,
        summaryGenerators: [],
        error: action.payload
      }
    case CREATE_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        summaryGenerator: {}
      }
    case DETAIL_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        summaryGenerator: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loadingDetail: false,
        summaryGenerator: {},
        error: action.payload
      }
    case UPDATE_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case UPDATE_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case UPDATE_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DUPLICATE_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DUPLICATE_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case DUPLICATE_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loading: false,
        summaryGenerator: {},
        error: action.payload
      }
    case DUPLICATE_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case DUPLICATE_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case DUPLICATE_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DELETE_SUMMARY_GENERATOR_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        services: state.services
      }
    case DELETE_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default summaryGeneratorReducer

